const $$splitComponentImporter = () => import('/home/runner/work/inspecttec-frontend-admin/inspecttec-frontend-admin/src/routes/client/groups/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { Permissions } from "@/constants/permissions";
import { requirePermission } from "@/lib/auth/permission-guard";
import { type UserGroupListItem } from "@/types/api/user-group";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/client/groups/")({
  beforeLoad: args => requirePermission(Permissions.Support.ViewClientData, args),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});

/** Mirrors the backend `StarterPackUserGroupCatalog` (name → system role). */

/**
 * Client user groups (founder, 2026-09-14): type, roles the group grants,
 * members (names on hover), inspection configurations it inspects, courses,
 * warnings, an automatic summary, search + Type / Status filters, and a
 * banner that creates the starter groups the client is missing.
 * Data: Client `UserGroup/GetAll` through the admin `GET /usergroups` proxy.
 */

/** e.g. "3 members · grants Inspector · inspects 6 configurations". */

/**
 * Active configurations the group inspects (active link + active
 * configuration). `inspectorGroupCount` also counts inactive links and
 * inactive configurations, so it can disagree with the names.
 */

/** A count that opens the group on the matching tab; names on hover. */